import React from "react";
import { Alert, Card, CardBody, Col, Form, Row, Spinner } from "reactstrap";


import OtherForm from "./OtherForm";

const LOAForm: React.FC<{
  loading: boolean;
  isUpdate?: boolean;
  validation: any;
  fieldErrors: any;
}> = ({ validation, isUpdate, loading, fieldErrors }) => {
  return (
    <Form
      className="tablelist-form"
      onSubmit={(e) => {
        e.preventDefault();
        validation.handleSubmit();
        return false;
      }}
    >
      {fieldErrors.length > 0 && (
        <div className="mb-3">
          <Alert color="danger" className="material-shadow">
            {fieldErrors.map((error: any, index: any) => (
              <div key={index}>
                <strong>{error.field}:</strong> {error.message}
              </div>
            ))}
          </Alert>
        </div>
      )}
      <Row>
        <Col md={12} className="mb-3">
          <OtherForm validation={validation} />

          <Card>
            <CardBody>
              <Row className="mb-1">
                <div className="hstack gap-2 justify-content-between">
                  <button type="button" className="btn btn-light">
                    Back
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading && (
                      <Spinner
                        color="light"
                        size="sm"
                        style={{ marginRight: "8px", marginBottom: "-1px" }}
                      />
                    )}
                    {isUpdate ? "Update Request" : "Submit Request"}
                  </button>
                </div>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Form>
  );
};

export default LOAForm;
